import docImg from './../../../static/images/file-img.svg'
import downloadIcon from './../../../static/images/download-icon.svg'
const handleDownload = async (fileUrl, doc_name) => {
console.log(fileUrl)
    try {
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = doc_name; // Replace with the desired file name
        link.click();

        URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Error occurred while downloading the file:', error);
    }
}

const Document = ({doc_name ,mediUrl}) => {
    console.log(mediUrl)
    return (
        <>
            <div onClick={() => handleDownload(mediUrl, doc_name)} class="message icon-hand download">
                
                <div class="pdownload-copy-wrapper">
                    <dl>
                        <dt><img src={docImg} /></dt>
                        <dd>
                            <h4>{doc_name}</h4>
                            <span class="about-prd">Car Insurance</span>
                        </dd>
                        <dt class="textcenter"><img src={downloadIcon}/></dt>
                    </dl>
                </div>
            </div>
        </>
    )
}
export default Document